<template>
  <div class="hello">
    <el-container>
      <el-aside width="136px" class="leftEvt">
        <img src="../assets/logo copy.png" alt="" class="img_one">
        <div class="div_one"  >
          <b @click="handleMenuClick('1')"  >Work</b>
          <span @click="handleMenuClick('2')">Interior</span>
          <span @click="handleMenuClick('3')">Exterior</span>
          <span @click="handleMenuClick('4')">Animation</span>
          <span @click="handleMenuClick('5')">VR360</span>
          <b @click="handleMenuClick('6')">About</b>
          <b @click="handleMenuClick('7')">Contact</b>

          <div style="display: flex;flex-direction: column;align-items: center;">
            <a href="https://www.behance.net/vrvimiu"><img src="../assets/Behance.png" alt=""
                style="margin-top: 22px;"></a>
            <a href="https://instagram.com/vimiu.renderstudio?r=nametag"> <img src="../assets/Ins.png" alt=""
                style="margin-top: 15px;"></a>
            <a href="https://www.pinterest.com/VimiuNews/_created/"> <img src="../assets/Pinterest.png" alt=""
                style="margin-top: 15px;"></a>
          </div>
        </div>
      </el-aside>
      <el-main>
        <div style=" line-height: 2;font-size: 15px;margin-top:120px;margin-left: 10px;text-align: left;text-indent: 2em;">
              <p>Visit US</p>
              <p> <strong>Chengdu:</strong> <span> Hi-Tech District ldealism City building 3 Office 1608, Chengdu</span></p>
              <p> <strong>Shanghai:</strong> <span> No.428 South Yanggao Road 2F,Shanghai</span></p>
              <p> <strong>HongKong:</strong> <span> Room 16,13A/F, South Tower,World Finance Centre,Harbour City,17 Canton Road,Tsim Sha Tsui,Kowloon,HongKong</span></p>
              <p><span>Email</span>: info@vimiuvr.com</p>
              <p >Media</p>
              <p>
                <a href="https://www.linkedin.com/company/vimiu-digital-technology/">LinkedIn</a>

                <a href="https://www.instagram.com/vimiu.renderstudio/"  style="margin-left: 20px;"> Instagram</a>
              </p>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>


export default {
  name: 'HelloWorld',
  data() {
    return {

    }
  },
  created() {

  },

  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    handleMenuClick(index) {
      this.localActiveIndex = index; // 更新当前选中的菜单项的值
      // 根据菜单项的值进行路由跳转
      switch (index) {
        case '1':
          this.$router.push('/');
          break;
        case '2':
          this.$router.push('/interior');
          break;
        case '3':
          this.$router.push('/Exterior');
          break;
        case '4':
          this.$router.push('/Animation');
          break;
        case '5':
          this.$router.push('/VR');
          break;
        case '6':
          this.$router.push('/About');
          break;
        case '7':
          this.$router.push('/Contact');
          break;
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../assets/js/flex-images.css");

.el-header,
.el-footer {
  background-color: #B3C0D1;
  color: #333;
  text-align: center;
}

.el-aside {
  background-color: #fff;
  color: #333;
  text-align: center;
}

/deep/.el-main {
  background-color: #fff;
  color: #333;
  text-align: center;

}

/deep/.el-main {
  height: 100vh;
  padding: 0px !important;
}


.leftEvt {
  .img_one {
    width: 88px;
    display: block;
    margin-top: 47px;
    margin-left: 25px;
  }

  img {
    width: 22px;
    height: 22px;
  }

  .div_one {
    width: 75px;
    height: 316px;
    margin: 30px auto 0 auto;
  }

  b {
    display: block;
    height: 25px;
    text-align: left;
    font-size: 15px;
  cursor: pointer;
  }

  b:nth-of-type(2) {
    margin-top: 22px;
    color: #6f6d6d;
    font-size: 12px;
    font-weight: 400;
  }

  b:nth-of-type(3) {
    color: #6f6d6d;
    font-size: 12px;
    font-weight: 400;
    color: #960a0a;

  }

  span {
    font-size: 12px;
    color: #6f6d6d;
    cursor: pointer;
  }

  span:nth-child(4) {
    margin-left: 15px;
  }
}


/deep/ .flex-images {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  // display: grid;
  // grid-template-columns: 1fr 1fr 1fr 1fr 1fr  1fr;
  // grid-template-rows: 1fr 1fr;
}

.img-box {
  background: #fff;
}

.img-box .item {
  position: relative;
  display: flex !important;
  justify-content: center;
  border: none;
}

.img-box .item img {
  width: 100%;
  object-fit: contain;
}

.item_one {
  position: relative;
  // display: flex !important;
  // justify-content: center;
  border: none;
}


.select {
  position: absolute;
  right: -25px;
  top: -25px;
  width: 0;
  height: 0;
  border: 25px solid;
  border-color: transparent #409eff transparent transparent;
  transform: rotate(135deg);
  color: #fff;
}

.select1 {
  position: absolute;
  left: 10px;
  top: 9px;
  width: 36px;
  height: 24px;
  color: #fff;
  background: #dd127b;
  border-radius: 6px;
  line-height: 24px;
  text-align: center;
  font-size: 12px;
}

.el-icon-check {
  position: absolute;
  font-size: 18px;
  top: -9px;
  left: 5px;
  transform: rotate(223deg);
}

.block1 {
  position: fixed;
  right: 1%;
  top: 1%;
}



.image-container {
  position: relative;
}

.prev-button {
  position: absolute;
  left: 0;
  top: 0%;
  height: 800px;
  width: 300px;
  opacity: 0;
}

.prev-button:hover {
  cursor: url(""), auto;

}

.next-button {
  position: absolute;
  right: 0;
  top: 0%;
  height: 800px;
  width: 300px;
  opacity: 0;
}

.next-button:hover {
  cursor: url(""), auto;
}

.fullscreen {
  position: fixed;
  top: 0;
  left: 140px;
  width: calc(100% - 1%);
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.fullscreen img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  cursor: pointer;
}

@media screen and (min-width: 0px) and (max-width: 1920px) {
  .fullscreen {
    width: calc(100% - 6%) !important;
  }
}

@media screen and (min-width: 1921px) and (max-width: 2560px) {
  .fullscreen {
    width: calc(100% - 6%) !important;
  }
}

@media screen and (min-width: 2561px) and (max-width:3440px) {}

@media screen and (min-width: 3441px) and (max-width: 3840px) {
  .fullscreen {
    width: calc(100% - 1%) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue